import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Dropdown,
  Image,
  message,
  Select,
  Modal,
  Switch,
} from "antd";
import { TableGrid } from "../../../Component/Table";
import "./style.scss";
import Api from "../../../Network/ApiConfig";
import {
  DownOutlined,
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import en from "../../../localization/en";
import ar from "../../../localization/ar";
import { useSelector } from "react-redux";
const { Option } = Select;
const { confirm } = Modal;

export const Companies = () => {
  const history = useHistory();
  const { currentLang } = useSelector((state) => state?.user);
  const [page, setpage] = useState(0);

  const t = currentLang === "en" ? en : ar;

  const handelDltRowData = (Id) => {
    confirm({
      title: `${t.DoyouWanttodeletethis} ${t.Company}?`,
      // title: localization.DodeletetheseAddress[this.props.currentLang],
      icon: <ExclamationCircleOutlined />,
      okText: t.Ok,
      cancelText: t.Cancel,
      onOk: () => {
        setLoading(true);
        Api.get(`AdminAPIs/DeleteCompany?CompanyId=${Id}`).then(
          (res) => {
            if (res?.status === 200) {
              // setLeadsList(res?.data?.model);
              // setLeadsListFiltered(res?.data?.model);
              fetchLeedsList();
            }
          },
          (err) => {
            setLoading(false);
          }
        );
      },
      onCancel() {},
    });
  };

  const handelChangeCompanyStatus = (data) => {
    console.log(data);
    setLoading(true);

    Api.get(
      `AdminAPIs/ChangeCompanyStatus?CompanyId=${data?.Id}&IsActive=${data?.AspNetUsers?.Disabled}`
    ).then(
      (res) => {
        if (res?.status === 200) {
          // setLeadsList(res?.data?.model);
          // setLeadsListFiltered(res?.data?.model);
          fetchLeedsList();
        }
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const columns = [
    {
      title: <p className="table-header-text"> # </p>,
      dataIndex: "key",
    },
    // {
    //   title: <p className='table-header-text'> # </p>,
    //   dataIndex: 'Id',
    // },
    {
      title: <p className="table-header-text">{t.name} </p>,
      dataIndex: currentLang === "en" ? "Name" : "NameLT",
    },
    {
      title: <p className="table-header-text"> {t.Phonenumber}</p>,
      dataIndex: "user_phone",
      render: (_, record) =>
        record?.AspNetUsers && (
          <a
            href={`tel:${
              record?.AspNetUsers?.PhoneKey + record?.AspNetUsers?.PhoneNumber
            }`}
          >
            {record?.AspNetUsers?.PhoneKey + record?.AspNetUsers?.PhoneNumber}{" "}
          </a>
        ),
    },
    // {
    //   title: <p className='table-header-text'> National Id Card <span> بطاقة الهوية الوطنية</span></p>,
    //   render: (_, record) => <Image src={record?.AspNetUsers?.FullName} />,
    // },
    {
      title: <p className="table-header-text"> {t.active}</p>,
      render: (_, record) => (
        <Switch
          onChange={() => handelChangeCompanyStatus(record)}
          checked={!record?.AspNetUsers?.Disabled}
        />
      ),
    },
    {
      title: <p className="table-header-text">{t.Actions}</p>,
      dataIndex: "",
      render: (_, record) => {
        return (
          <div className="select-item-action">
            <EditOutlined
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                // handelEditRowData(record?.Id);
                history.push({ pathname: "/add-company", state: record });
              }}
              style={{ marginInlineEnd: 20, fontSize: 20, cursor: "pointer" }}
            />
            <DeleteOutlined
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handelDltRowData(record?.Id);
              }}
              style={{
                marginInlineEnd: 20,
                color: "red",
                fontSize: 20,
                cursor: "pointer",
              }}
            />
          </div>
        );
      },
    },
  ];

  const pdfRef = React.createRef();
  const [leadsList, setLeadsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [defaultCurrentVal, setDefaultCurrentVal] = useState(10);
  const [tableColumn, setTableColumn] = useState(columns);
  const [leadsListFiltered, setLeadsListFiltered] = useState([]);
  const [checkedList, setCheckedList] = useState(
    columns.map((item) => {
      return item.dataIndex;
    })
  );
  const [indeterminate, setIndeterminate] = useState(true);
  const [checkAll, setCheckAll] = useState(true);
  const [excelData, setExcelData] = useState([]);
  const [pdfData, setPdfData] = useState([]);
  const [TotalCount, setTotalCount] = useState(30);

  // const [pdfTableColumns, setPdfTableColumns] = useState(pdfColumns);
  const checkBoxColumn = columns.map((item) => {
    return { label: item.title, value: item.dataIndex };
  });

  const onChange = (list) => {
    // if (list?.length === 0) return
    let tableColumnClone = [];
    columns.map((item) => {
      if (list.includes(item.dataIndex)) {
        tableColumnClone.push(item);
      }
    });

    setTableColumn(tableColumnClone);
    setCheckedList(list);
    setIndeterminate(!!list.length && list.length < checkBoxColumn.length);
    setCheckAll(list.length === checkBoxColumn.length);
  };

  const fetchLeedsList = (index = 0) => {
    setLoading(true);
    setpage(index);
    Api.get(`AdminAPIs/GetCompanies?Page=${index}`).then(
      (res) => {
        if (res?.status === 200) {
          const dataSource = res?.data?.model.map((item, ind) => ({
            ...item,
            key: ind + 1 + index * 30, // Or any other unique identifier
          }));
          setLeadsList(dataSource);
          setLeadsListFiltered(dataSource);
        }
        if (res?.data?.metas?.TotalaCount) {
          setTotalCount(res?.data?.metas?.TotalaCount);
        }
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    fetchLeedsList();
  }, [currentLang]);

  return (
    <div>
      <TableGrid
        TableRef={pdfRef}
        title={
          <div className="table__filter">
            <p style={{ fontWeight: "bold" }}> {t.Companies}</p>
            <div className="product__btn">
              <Button
                onClick={() => history.push("/add-company")}
                className="primary"
              >
                {" "}
                {t.NewCompany}{" "}
              </Button>
            </div>
          </div>
        }
        columns={columns}
        dataSource={leadsList || []}
        // pagination={{ pageSize: 30, total: 44 }}
        // defaultCurrent={30}
        pageSize={30}
        loading={loading}
        total={TotalCount}
        onChange={(pagination) => {
          fetchLeedsList(pagination?.current - 1);
        }}
        pdfData={pdfData}
        // pdfTableColumns={pdfTableColumns}
      />
    </div>
  );
};
